import { render, staticRenderFns } from "./KoioteExcelReader.vue?vue&type=template&id=3821b926&"
import script from "./KoioteExcelReader.vue?vue&type=script&lang=js&"
export * from "./KoioteExcelReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports